import React, { useState } from "react";
import { compose } from "redux";
import {
  Container,
  Text,
  withStyles,
  withDrawer,
  Xs,
  Md,
  Drawer2,
} from "components/common";
import { convertToShortDate } from "utils/convert-date";
import formatCurrency from "utils/formatCurrency";
import PaymentDrawer from "../Payments/PaymentDrawer";

const NextPayment = ({ user, onSuccessfulPayment }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const paymentDueDate = user.payment_due_date
    ? convertToShortDate(user.payment_due_date)
    : "No due date";

  // const amountDue = ["weekly", "biweekly"].includes(user.autopay_frequency)
  //   ? user.credit.credit_used
  //   : -user.payment_due_balance;
  const amountDue = -user.payment_due_balance;

  const amountDisplayed =
    amountDue > 0 ? `${formatCurrency(amountDue)}` : "No payment due";

  return (
    <>
      <Container
        paddingVertical={28}
        paddingHorizontal={24}
        className="w-full flex-1 justify-center"
      >
        <Xs to="md">
          <div className="flex flex-col items-center md:items-start">
            <div className="flex flex-col items-center mb-3 lg:items-start">
              <Text className="font-bold text-xl">Next Payment Due</Text>
            </div>
            <div className="md:flex mb-4 md:mb-2">
              <div className="flex">
                <Text className="font-bold mr-2 mb-2">Amount:</Text>
                <Text className="">{amountDisplayed}</Text>
              </div>
              <div className="flex md:ml-2 md:pl-2 md:border-l">
                <Text className="font-bold mr-2">Due Date:</Text>
                <Text className="">{paymentDueDate}</Text>
              </div>
            </div>
            <button
              type="button"
              className="w-full btn dashboard-pay-btn"
              style={{ marginTop: 8 }}
              onClick={() => setDrawerOpen(true)}
            >
              Quick Pay
            </button>
          </div>
        </Xs>
        <Md>
          <div className="flex flex-col items-center">
            <div className="flex flex-col items-center mb-5">
              <Text className="font-bold mb-2 text-base">
                Next Payment Due:
              </Text>
              <Text className="text-gray-primary">{paymentDueDate}</Text>
            </div>
            <div className="hidden md:flex flex-col items-center text-center mb-5">
              <Text className="font-bold mb-2 text-base">Amount due:</Text>
              <Text className="text-gray-primary">{amountDisplayed}</Text>
            </div>

            <button
              type="button"
              className="w-full btn dashboard-pay-btn"
              style={{ marginTop: 8 }}
              onClick={() => setDrawerOpen(true)}
            >
              Quick Pay
            </button>
          </div>
        </Md>
      </Container>
      <Drawer2 isOpen={drawerOpen} close={() => setDrawerOpen(false)}>
        <PaymentDrawer
          amount={(amountDue > 0 ? amountDue : 0).toFixed(2)}
          user={user}
          closeDrawer={() => setDrawerOpen(false)}
          onSuccessfulPayment={onSuccessfulPayment}
          showAmountSelectors
          showForm
        />
      </Drawer2>
    </>
  );
};

export default compose(withStyles, withDrawer)(NextPayment);
